import { ReactNode, createContext, useContext } from 'react';
import { DisplayData } from './adapter';

const ResultContext = createContext<DisplayData | null>(null);

export const ResultProvider = ({
  data,
  children,
}: {
  data: DisplayData;
  children: ReactNode;
}) => <ResultContext.Provider value={data}>{children}</ResultContext.Provider>;

export const useResultData = (): DisplayData => {
  const data = useContext(ResultContext);
  if (!data) {
    throw new Error('useResultData must be called inside <ResultProvider>');
  }
  return data;
};
